export const SUPER_ADMIN_EMAIL = 'adithyanbrototype@gmail.com'; // Replace with your super admin email 